import React, { FC } from 'react'

import { Block } from '@Generated/graphql'
import { getRTEFieldText } from '@Globals/CMS/FieldHelpers'

import styles from './QuoteBlock.module.scss'

interface QuoteBlockProps {
  id?: string
  quoteBlock: Block
}
const QuoteBlock: FC<QuoteBlockProps> = ({ id, quoteBlock }) => {
  const text = getRTEFieldText(quoteBlock.fields || [], 'text')
  if (!text) {
    return null
  }

  return (
    <blockquote className={styles.quote} dangerouslySetInnerHTML={{ __html: text }} id={id} />
  )
}

export default QuoteBlock
